







































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import AMSBreadcrumb from '@/components/AMSBreadcrumb.vue';
import AMSformTable from '@/components/AMSformTable.vue';
import request from '@/utils/request';
import { AppStore } from '@/store/modules/app';
import AMSDialog from '@/components/AMSDialog.vue';
import AMSProduct from '@/components/AMSProductCategorySelector.vue';
import Utils from '@/utils/utils';

import { allStaff } from '@/api/staff';
import { activeCustomer } from '@/api/customer';
import moment from 'moment';
import utils from '@/utils/utils';
import { getModuleName } from '@/utils/utils';
interface Form {
  filter?: string;
  salesId?: string | null;
  beautyAdvisorsId?: string | null;
  signDateBegin?: string;
  signDateEnd?: string;
  isActive?: boolean | null;
}
@Component({
  components: {
    'ams-formtable': AMSformTable,
    'ams-breadcrumb': AMSBreadcrumb,
    'ams-dialog': AMSDialog,
    'ams-product': AMSProduct
  }
})
export default class CustomerList extends Vue {
  form: Form = {
    salesId: '',
    isActive: null
  };
  BreadItem = [
    {
      text: '客户管理',
      disabled: false,
      href: '/customer'
    },
    {
      text: '客户列表',
      disabled: true
    }
  ];
  staffList = [{ text: '全部', value: null }];
  statusList = [{ text: '全部', value: null }, { text: '已启用', value: true }, { text: '已禁用', value: false }];
  api: string = '/api/Customer/List';
  signDateBegin = false;
  signDateEnd = false;
  dateBegin: string = '';
  dateEnd: string = '';
  date = new Date().toISOString().substr(0, 10);
  activeDialog: boolean = false;
  activeId: string = '';
  get minDate() {
    return this.form.signDateBegin;
  }
  regionApi: string = '/api/System/Region/Tree';
  headers: object[] = [
    { text: '客户名', align: 'left', sortable: false, value: 'name', width: 140, status: 'isActive' },
    { text: '联系人', align: 'left', sortable: false, value: 'contactPerson', width: 120, status: 'isActive' },
    {
      text: '地址',
      align: 'left',
      sortable: false,
      value: 'address',
      render: (h: any, param: any) => {
        return h('div', { ...utils.stausRenderDiableColor(param.row.isActive) }, this.renderAddress(param));
      },
      width: 200
    },
    { text: '手机号', align: 'left', sortable: false, value: 'phone', width: 120, status: 'isActive' },
    {
      text: '销售',
      align: 'left',
      sortable: false,
      value: 'sales',
      render: (h: any, param: any) => {
        return h('div', { ...utils.stausRenderDiableColor(param.row.isActive), domProps: { innerHTML: this.renderList(param) } });
      },
      width: 120
    },
    {
      text: '美导',
      align: 'left',
      sortable: false,
      value: 'beautyAdvisors',
      render: (h: any, param: any) => {
        return h('div', { ...utils.stausRenderDiableColor(param.row.isActive), domProps: { innerHTML: this.renderList(param) } });
      },
      width: 120
    },
    {
      text: '账户余额',
      align: 'right',
      sortable: false,
      value: 'totalBalance',
      isCurrency: true,
      width: 140,
      status: 'isActive'
    },
    {
      text: '签约日期',
      align: 'left',
      sortable: false,
      value: 'signDate',
      isFormatDate: true,
      width: 100,
      status: 'isActive'
    },
    {
      text: '操作',
      value: 'actions',
      sortable: false,
      align: 'center',
      isDetail: [
        {
          routerName: 'customer_detail',
          text: '查看',
          color: '#1ABC9C',
          isParams: true
        },
        {
          routerName: 'customer_edit',
          text: '修改',
          color: '#1ABC9C',
          isParams: true,
          isShowBtn: (row: any) => {
            return Utils.isPermission('CustomerManager.CustomerList.CreateOrEdit');
          }
        },
        {
          callBack: (btn: any, row: any, key: string) => {
            this.confirmItem(btn, row, key);
          },
          text: '禁用',
          color: '#1ABC9C',
          isShowBtn: (row: any) => {
            return row.isActive && Utils.isPermission('CustomerManager.CustomerList.ToggleActive');
          }
        },
        {
          callBack: (btn: any, row: any, key: string) => {
            this.confirmItem(btn, row, key);
          },
          text: '启用',
          color: '#1ABC9C',
          isShowBtn: (row: any) => {
            return !row.isActive && Utils.isPermission('CustomerManager.CustomerList.ToggleActive');
          }
        },
        {
          callBack: (btn: any, row: any, key: string) => {
            this.confirmOperate(row.item, 'password');
          },
          text: '重置密码',
          color: '#1ABC9C',
          isParams: true,
          isShowBtn: (row: any) => {
            return !row.isSuperAdmin && Utils.isPermission('CustomerManager.CustomerList.ResetPWD');
          }
        }
      ],
      width: 180
    }
  ];

  showDialog: boolean = false;
  requestLoading: boolean = false;
  updateStatusItem: any = {};

  onIsActiveClear() {
    setTimeout(() => {
      this.form.isActive = null;
    }, 1);
  }

  onEnter() {
    this.$refs.signDateBeginText && (this.$refs.signDateBeginText as any).blur();
    this.$refs.signDateEndText && (this.$refs.signDateEndText as any).blur();
  }

  @Watch('signDateBegin', { immediate: true, deep: true })
  onBeginTimeChange(newValue: boolean, oldValue: boolean) {
    const text = this.$refs.signDateBeginText as any;
    if (text && newValue == false) {
      text.focus();
    }
  }

  @Watch('signDateEnd', { immediate: true, deep: true })
  onEndTimeChange(newValue: boolean, oldValue: boolean) {
    const text = this.$refs.signDateEndText as any;
    if (text && newValue == false) {
      text.focus();
    }
  }

  @Watch('dateBegin', { immediate: true, deep: true })
  onDateBeginChange(newValue: string, oldValue: string) {
    this.form.signDateBegin = newValue ? moment(newValue).toISOString() : '';
  }
  @Watch('dateEnd', { immediate: true, deep: true })
  onDateEndChange(newValue: string, oldValue: string) {
    this.form.signDateEnd = newValue ? moment(newValue).toISOString() : '';
  }

  onSalesIdClear() {
    setTimeout(() => {
      this.form.salesId = null;
    }, 1);
  }

  onBeautyAdvisorsIdClear() {
    setTimeout(() => {
      this.form.beautyAdvisorsId = null;
    }, 1);
  }

  created() {
    this.getStaff();
    this.initForm();
    if (JSON.parse(localStorage.getItem(`${getModuleName(this.$route.name as string)}_search`) as string)) {
      this.form = JSON.parse(localStorage.getItem(`${getModuleName(this.$route.name as string)}_search`) as string);
      this.dateBegin = this.form.signDateBegin ? moment(this.form.signDateBegin).format('YYYY-MM-DD') : '';
      this.dateEnd = this.form.signDateEnd ? moment(this.form.signDateEnd).format('YYYY-MM-DD') : '';
    }
  }
  getPermission(name: string) {
    return Utils.isPermission(name);
  }
  initForm() {
    this.form = { salesId: null, beautyAdvisorsId: null, isActive: null };
    this.dateBegin = '';
    this.dateEnd = '';
  }
  getStaff() {
    allStaff({ isActive: true, permissionCheck: true }).then((data: any) => {
      this.staffList = [{ value: null, text: '全部' }].concat(
        data.items.map((i: any) => {
          i.value = i.id;
          i.text = i.name;
          return i;
        })
      );
    });
  }
  addNew() {
    this.$router.push({
      name: 'customer_create'
    });
  }
  exportAll() {
    this.$router.push({ name: 'importCustomer' });
  }

  confirmItem(btn: any, row: any, key: string) {
    this.showDialog = true;
    this.updateStatusItem.id = row.item.id;
    this.updateStatusItem.isNormal = row.item.isActive;
  }
  cancel() {
    this.showDialog = false;
    this.updateStatusItem = {};
  }

  sure() {
    this.requestLoading = true;
    activeCustomer(this.updateStatusItem.id.toString())
      .then((data: any) => {
        (this.$refs['formtable'] as HTMLFormElement).query();
        this.updateStatusItem = {};
        this.showDialog = false;
        AppStore.ShowSuccess('操作成功！');
      })
      .catch(() => {
        AppStore.ShowError('操作失败！');
      })
      .finally(() => {
        this.requestLoading = false;
      });
  }
  renderList(param: any) {
    let staffs = param.row[param.keyName].map((k: any) => {
      return k.staff.name;
    });
    return staffs.join('<br />');
  }
  renderAddress(param: any) {
    return (param.row.region ? param.row.region.fullName : '') + (param.row.address ? param.row.address : '');
  }
  activeStaff() {
    this.activeDialog = false;
  }
  confirmOperate(item: any, type: string) {
    const self = this;
    self.activeDialog = true;
    self.activeId = item.id;
  }
  activeSure() {
    this.requestLoading = true;
    const self = this;
    request
      .put(`/api/Customer/${self.activeId}/resetPwd`, null)
      .then((data: any) => {
        this.activeDialog = false;
        AppStore.ShowSuccess('操作成功！密码已经重置，默认为手机号码后6位');
        (this.$refs.formtable as HTMLFormElement).query();
        this.requestLoading = false;
      })
      .finally(() => {
        this.requestLoading = false;
      })
      .catch((err: any) => {
        this.requestLoading = false;
        AppStore.ShowError(`操作失败！`);
      });
  }
}
